import { render, staticRenderFns } from "./AddEditRoles.vue?vue&type=template&id=2ba80700&scoped=true"
import script from "./AddEditRoles.vue?vue&type=script&lang=js"
export * from "./AddEditRoles.vue?vue&type=script&lang=js"
import style0 from "./AddEditRoles.vue?vue&type=style&index=0&id=2ba80700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba80700",
  null
  
)

export default component.exports